<template>
    <div>
        <p><a href="https://lixvyang.github.io/">Mixin:39427696</a></p>
    </div>
</template>

<script>
export default {
    name:"About",
}

</script>

<style>
    p,a{
        color: aliceblue;
        font-size: 15px;
    }
</style>